module.exports = __webpack_public_path__ + "img/bryan.558bce10.jpg";